var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main"},[_c('ul',{staticClass:"box-list"},_vm._l((_vm.list),function(item){return _c('li',{key:item.name},[_c('router-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(item.name))])],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }